import { render } from "./MetaMask.vue?vue&type=template&id=907d7366&scoped=true"
import script from "./MetaMask.vue?vue&type=script&lang=js"
export * from "./MetaMask.vue?vue&type=script&lang=js"

import "./MetaMask.vue?vue&type=style&index=0&id=907d7366&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-907d7366"]])

export default __exports__